import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import config from "../../config";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
  input: {
    display: "none",
  },
  inputSmall: {
    width: "94%",
    marginLeft: theme.spacing(),
  },
  inputLarge: {
    width: "98%",
    marginLeft: theme.spacing(),
  },
  card: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
  margin: {
    color: "#F6277F",
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "70%",
    marginLeft: "15%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
});

class BrandView extends Component {
  state = {
    brandData: [],
    isEdit: false,
    openDeleteDialog: false,
    openAcceptDialog: false,
  };
  constructor(props) {
    super(props);
    if (props.match.params.id) {
      axios
        .get(BACKEND_URL + "/brand/" + props.match.params.id)
        .then((response) => this.loadData(response.data))
        .catch((err) => {
          //  console.log(err)
        });
    }
  }

  loadData(brand) {
    // console.log(brand)
    this.setState({ brandData: brand });
  }

  btnAcceptOnClick(id, e) {
    this.setState({
      deleteId: id,
      openAcceptDialog: true,
    });
  }

  btnDeleteOnClick(id, e) {
    this.setState({
      deleteId: id,
      openDeleteDialog: true,
    });
  }

  proccedDelete() {
    axios
      .post(BACKEND_URL + `/brand/acceptCompanyCommunity`, {
        brand_id: this.state.deleteId,
        accept: false,
      })
      .then(this.props.history.goBack())
      .catch(function (error) {
        // console.log(error);
      });
    this.setState({
      deleteId: "",
      openDeleteDialog: false,
    });
  }

  proccedAccept() {
    axios
      .post(BACKEND_URL + `/brand/acceptCompanyCommunity`, {
        brand_id: this.state.deleteId,
        accept: true,
      })
      .then(this.props.history.goBack())
      .catch(function (error) {
        // console.log(error);
      });
    this.setState({
      deleteId: "",
      openAcceptDialog: false,
    });
  }

  cancelAction() {
    this.props.history.goBack();
  }

  cancelDelete() {
    this.setState({
      deleteId: "",
      openDeleteDialog: false,
      openAcceptDialog: false,
    });
  }

  render() {
    const { classes } = this.props;
    const { brandData } = this.state;
    return (
      <div>
        <Grid container alignItems="flex-start" style={{ marginLeft: "16.5%" }}>
          <Grid xs={8}>
            <Typography
              variant="h4"
              style={{ marginTop: "2%", marginBottom: "2%" }}
            >
              Brand {brandData.name} Information
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{ paddingBottom: "2%" }}
        >
          <Grid xs={12}>
            <fieldset className={classes.fieldset}>
              <legend className={classes.legend_text}>Brand Information</legend>
              <Grid container>
                <b>Brand Name : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={brandData.name}
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Contact First Name : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.contact
                      ? brandData.contact.first_name
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Contact Last Name : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.contact
                      ? brandData.contact.last_name
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Contact Phone Number : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.contact
                      ? brandData.contact.phone_number
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Contact Email : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.contact ? brandData.contact.email : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Brand License Number : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.license_number
                      ? brandData.license_number
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Brand License type : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.license_type
                      ? brandData.license_type
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <Grid xs={8}>
                  <b>Website : </b>
                </Grid>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={brandData.website ? brandData.website : "Not Provided"}
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Business Type : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={brandData.type ? brandData.type : "Not Provided"}
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Address Line 1 : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.address_line1
                      ? brandData.address_line1
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Address Line 2 : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.address_line2
                      ? brandData.address_line2
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <Grid xs={8}>
                  <b>Postal Code : </b>
                </Grid>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.postal_code
                      ? brandData.postal_code
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <Grid xs={8}>
                  <b>Province : </b>
                </Grid>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.province ? brandData.province : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <Grid xs={8}>
                  <b>City : </b>
                </Grid>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={brandData.city ? brandData.city : "Not Provided"}
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <Grid xs={8}>
                  <b>Country : </b>
                </Grid>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={brandData.country ? brandData.country : "Not Provided"}
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid container>
                <b>Additional Comments : </b>
                <TextField
                  style={{ width: "90%" }}
                  variant="outlined"
                  margin="normal"
                  value={
                    brandData.additional_comments
                      ? brandData.additional_comments
                      : "Not Provided"
                  }
                  InputLabelProps={{ style: { color: "grey" } }}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </fieldset>
          </Grid>
        </Grid>
        <Grid
          align="center"
          justify="space-evenly"
          container
          alignItems="center"
          style={{ paddingBottom: "2%" }}
        >
          <Tooltip title="Accept">
            <IconButton
              aria-label="Accept Brand"
              className={classes.margin}
              onClick={this.btnAcceptOnClick.bind(this, brandData._id)}
            >
              <CheckIcon fontSize="large" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Reject">
            <IconButton
              aria-label="Reject Brand"
              className={classes.margin}
              onClick={this.btnDeleteOnClick.bind(this, brandData._id)}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancel">
            <IconButton
              aria-label="Cancel"
              className={classes.margin}
              onClick={() => this.cancelAction()}
            >
              <CancelIcon fontSize="large" />
            </IconButton>
          </Tooltip>
        </Grid>
        <Dialog
          open={this.state.openDeleteDialog}
          disableBackdropClick
          disableEscapeKeyDown
          aria-describedby="alert-dialog-description"
          TransitionComponent={this.transition}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure that want to delete this brand?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.cancelDelete.bind(this)}
              color="primary"
              autoFocus
            >
              No
            </Button>
            <Button onClick={this.proccedDelete.bind(this)} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.openAcceptDialog}
          disableBackdropClick
          disableEscapeKeyDown
          aria-describedby="alert-dialog-description"
          TransitionComponent={this.transition}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure that want to accept the brand?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.cancelDelete.bind(this)}
              color="primary"
              autoFocus
            >
              No
            </Button>
            <Button onClick={this.proccedAccept.bind(this)} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

BrandView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BrandView);
